var React = require('react');

function IconLowRate (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m31 28.82v39.61h-23l56 42.75 56-42.75h-23v-39.61","key":0}),React.createElement("path",{"d":"m74.16 28.82-20.32 40.51","key":1}),React.createElement("circle",{"cx":"75.16","cy":"61.68","r":"7.65","key":2}),React.createElement("circle",{"cx":"52.84","cy":"36.47","r":"7.65","key":3})]);
}

IconLowRate.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = IconLowRate;

IconLowRate.default = IconLowRate;
